import { render, staticRenderFns } from "./ComplaintsPerStatus.vue?vue&type=template&id=9ff91e50&scoped=true&"
import script from "./ComplaintsPerStatus.vue?vue&type=script&lang=js&"
export * from "./ComplaintsPerStatus.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsPerStatus.vue?vue&type=style&index=0&id=9ff91e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff91e50",
  null
  
)

export default component.exports